// @flow
import WebComponent from '../src/webComponents/WebComponent';
import $ from 'jquery';
import '../edeeshop/jquery.fulltextAutocomplete';

export default class FulltextAutocomplete extends WebComponent {
	didMount() {
		$(this.element).fulltextAutocomplete({
			url: `/qf/${window.projectConfig.lang}/ramjet/fulltextAutocompleteResult`,
			lang: window.projectConfig.lang
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/FulltextAutocomplete.js